module.exports = __webpack_public_path__ + "static/media/svg-sprites-rexel.2ddd15d4.svg";